<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="劃位資源管理"
      fkey="rvm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="col-6 rc-bar-view">
      <store-rc-view
        ref="rcView"
        :op_hours="op_hours"
        :cal_blocks="cal_blocks"
        :has_map="has_map"
        :block_clicked="block_clicked"
      ></store-rc-view>
    </div>
    <div class="col-6 rv-list-view">
      <div
        v-if="filter_time===''"
      >
        <span>本日全部劃位：{{day_reserves_all.length}}人次</span>
      </div>
      <div
        v-if="filter_time!==''"
      >
        <b-link @click="return_all">全部</b-link><span>當前{{filter_time}}劃位:{{day_reserves.length}}人次</span>
      </div>
      <b-table
        :fields="reserve_fields"
        :items="day_reserves" 
      >
        <template v-slot:cell(reserve_user)="row">
          <b-link @click="operateReserve(row.item)">{{row.item.reserve_user}}</b-link>
        </template>
      </b-table>
    </div>
    <b-modal
      id="addModal"
      ref="addModal"
      v-model="modalAddShow"
      :static="true"
      :parentVue="this"
      centered
      hide-header
      hide-footer
      @hide="closeCheck"
      @shown="setFocus"
    >
      <add-private-reserve
        ref="apr"
        :target_date="filterData.viewDate"
        :op_hours="op_hours"
        :minuteInterval="service_minute_unit"
        :filter_start_time="filter_time"
        :cancel_create="closeExtAdd"
        :successReload="successReload"
      ></add-private-reserve>
    </b-modal>
    <b-modal
      id="operateModal"
      ref="operateModal"
      v-model="modalOperateShow" 
      centered
      :static="true"
      size="lg"
      hide-header
      hide-footer
    >
      <reserve-operate-view
        ref="rov"
        :target_date="filterData.viewDate"
        :op_hours="op_hours"
        :minuteInterval="service_minute_unit"
        :cancel_create="closeExtOperate"
        :successReload="successReload"
      ></reserve-operate-view>
    </b-modal>
    <b-modal
      id="infoModal"
      ref="infoModal"
      v-model="modalDetailShow" 
      centered
      :static="true"
      size="lg"
      hide-header
      hide-footer
    >
      <populate-form
        formTitle="劃位請求詳細資訊"
        fkey="rqd01"
        ref="detailForm"
        populateOptionVar="detailOptions"
        formDataObjVar="detailData"
        :parentVue="this"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowOffer" 
      centered
      size="lg"
      hide-header
      hide-footer
      :static="true"
    >
      <StoreOfferNegotiate ref="offerNegotiate" :lockedInviteDate="filterData.viewDate" :doneCB="finishOffer" />
    </b-modal>
  </div>
</template>

<script>

import StoreRcView from "./SubComponent/StoreRcView"
import AddPrivateReserve from './SubComponent/AddPrivateReserve'
import ReserveOperateView from './SubComponent/ReserveOperateView'
import StoreOfferNegotiate from './SubComponent/StoreOfferNegotiate'

export default {
  name: 'StoreRcManage',
  components:{
    StoreRcView,
    AddPrivateReserve,
    ReserveOperateView,
    StoreOfferNegotiate
  },
  props: {
    
  },
  data: function () {
    return {
      fromStack:[],
      fromParams:{},
      highlight_from:"",
      highlight_to:"",
      service_minute_unit:0,
      modalAddShow:false,
      modalOperateShow:false,
      modalDetailShow:false,
      modalShowOffer:false,
      detailData:{},
      detailOptions:[
        {
          componentType:'span',
          col:3,
          placeholder:"劃位日期:"
        },
        {
          componentType:'span',
          col:3,
          akey:"open_date"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"請求於:"
        },
        {
          componentType:'span',
          col:3,
          akey:"send_time"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"請求者:"
        },
        {
          componentType:'span',
          col:3,
          akey:"user_name"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"時效:"
        },
        {
          componentType:'span',
          col:3,
          akey:"expire_time"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"課程:"
        },
        {
          componentType:'span',
          col:9,
          akey:"ticket_project_name"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"劃位起:"
        },
        {
          componentType:'span',
          col:3,
          akey:"start_time"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"估計至:"
        },
        {
          componentType:'span',
          col:3,
          akey:"end_time"
        },
        {
          componentType:'span',
          col:3,
          placeholder:"請求說明:"
        },
        {
          componentType:'span',
          col:9,
          akey:"from_remark"
        },
        {
          componentType:'span',
          col:4,
        },
        {
          componentType:'b-button',
          col:4,
          placeholder:'關閉',
          execCallback:()=>{this.modalDetailShow = false}
        },
        {
          componentType:'span',
          col:4,
        },
      ],
      editItem:{},
      filterOptions:[
        {
          componentType:'span',
          col:10,
          akey:'request_info',
          hide:true,
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:"詳細",
          hide:true,
          execCallback:this.showReqDetail
        },
        {
          componentType:'btn-group',
          col:12,
          hide:true,
          buttons:[
            {
              placeholder:'返回',
              col:2,
              execCallback:this.goBack
            },
            {
              placeholder:'接受',
              col:3,
              execCallback:this.acceptNegotiate
            },
            {
              placeholder:'拒絕',
              col:3,
              execCallback:this.declineNegotiate
            },
            {
              placeholder:'其他',
              col:3,
              execCallback:this.resuggestNegotiate
            },
          ],
        },
        {
          componentType:'date-picker',
          defaultValue:this.toISODateString(new Date()),
          akey:'viewDate',
          col:3,
          placeholder:'檢視日期',
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          col:9,
          buttons:[
            {
              akey:"btnAddCustomR",
              col:4,
              placeholder: "自訂",
              btnIcon:'wrench',
              execCallback: this.showExtAdd
            },
            {
              akey:"btnInvite",
              col:4,
              placeholder: "邀約劃位",
              execCallback: this.showInvite
            }
          ]
        },
      ],
      filterData:{},
      view_date:null,
      // res_map貌似不用存起來= =
      has_map:false,
      op_hours:[],
      cal_blocks:[],

      day_reserves_all:[],
      day_reserves:[],
      filter_time:'',
      reserve_fields:[
        {
          key:'reserve_start_time',
          label:'開始時間'
        },
        {
          key:'reserve_user',
          label:'劃位者'
        }
      ]
    }
  },
  methods: {
    finishOffer() {
      // 要鎖住日期,讓邀約劃位日期是當前日期,這樣這頁的reload才有意義
      this.get_date_data()
      this.modalShowOffer = false
    },
    ConfirmRead() {
      let Param = {
        module:'merchant',
        method:'confirmReadNotification',
        mwct_id:this.fromParams.data.mwct_id
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.$bus.fnShowInfo("已設為讀取確認完成")
      }, this)
    },
    goBack() {
      // 這個頁面目前設計得可能會被多種情境跳轉呼叫,所以要提供跳回去的機制
      this.$bus.linkCallStack = this.fromStack
      // 還漏一個機制,回上頁時讓上一頁reload畫面資料,再想辦法補上

      this.$bus.landingComponent = this.fromStack[this.fromStack.length-1].landingComponent
    },
    showReqDetail() {
      this.detailData = this.CpObj(this.fromParams.data)
      this.$refs.detailForm.refreshModelVar()
      this.modalDetailShow = true
    },
    acceptNegotiate() {
      let Param = {
        module:'store',
        method:'confirmReservationApplyByStore',
        negotiation_id:this.fromParams.negotiation_id,
        new_status:'committed',
        resuggest_plot_id:0,
        reply_remark:''
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.$bus.fnShowInfo("更新完成")
        vm.get_date_data()
      }, this)
    },
    operateReserve(item) {
      this.$refs.rov.setData(item)
      this.modalOperateShow = true
    },
    showExtAdd() {
      if (this.op_hours.length === 0) {
        this.$bus.fnShowInfo('當前日期無法操作')
        return
      }
      this.$refs.apr.initDefault()
      this.modalAddShow = true
    },
    showInvite() {
      if (this.op_hours.length === 0) {
        this.$bus.fnShowInfo('當前日期無法操作')
        return
      }
      this.$refs.offerNegotiate.OpState = 'TicketList'
      this.modalShowOffer = true
    },
    closeExtAdd() {
      this.modalAddShow = false
    },
    closeExtOperate() {
      this.modalOperateShow = false
    },
    successReload(date) {
      // 看看popup上有無調整日期
      if (date !== undefined && date !== this.filterData.viewDate) {
        this.filterData.viewDate = date
        this.$refs.filterForm.refreshModelVar('viewDate')
      }
      this.get_date_data()
      this.modalAddShow = false
      this.modalOperateShow = false
      setTimeout(() => {
        this.$bus.fnShowInfo('已更新')
      }, 100);
    },
    filterChanged(upd) {
      this.get_date_data(upd)
    },
    closeCheck: function (evt) {
      if (this.modalAddShow) {
        evt.preventDefault()
      }
    },
    setFocus: function () {
      this.$refs.apr.$refs.addForm.setFocus('extSrcTypeId')
    },
    get_date_data() {
      let Param = {
        'module':'store',
        'method':'getStoreReserveViewOneDay',
        'date': this.filterData.viewDate,
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.day_reserves_all = vm.getSimpleReserve(data.data.day_reserves)
        vm.day_reserves = vm.day_reserves_all
        vm.processDateData(data.data.res_map)
      }, this)
    },
    block_clicked(block) {
      //alert("WOW!"+JSON.stringify(block))
      // 點擊左邊時段,用時段來filter右邊顯示的劃位
      this.day_reserves = []
      for (let i=0;i<this.day_reserves_all.length;i++) {
        if ((this.day_reserves_all[i].data.reserve_end_time > block.start_time &&
              this.day_reserves_all[i].data.reserve_start_time < block.end_time
          )) 
        {
          this.day_reserves.push(this.day_reserves_all[i])
        }
      }
      this.filter_time = this.getPartFromDatetimeStr(block.start_time,'hourminute')
    },
    return_all() {
      this.filter_time = ''
      this.day_reserves = this.CpObj(this.day_reserves_all)
    },
    getSimpleReserve(day_reserves) {
      let simple = []
      for (let i=0; i<day_reserves.length;i++) {
        simple.push({
          reserve_start_time:this.getPartFromDatetimeStr(day_reserves[i].reserve_start_time,'hourminute'),
          reserve_user:(day_reserves[i].reserve_type==='external_reserve'?('(外)'+day_reserves[i].reserve_user+day_reserves[i].reserve_remark):day_reserves[i].reserve_user),
          data:day_reserves[i]
        })
      }
      return simple
    },
    processDateData(res_map) {
      let start_hour = 8
      let end_hour = 20
      let start_key = null
      let last_key = null
      let datehour = null
      let prev_end_time = null
      // 計算右邊時段時間是幾分鐘
      let dt1 = null
      let dt2 = null
      this.op_hours = []
      this.cal_blocks = []
      // 因為是測試自己抓api而非由prop傳入所以需要setTimeout克服時間差
      for (let time_key in res_map) {
        if (!start_key) {
          start_hour = this.getPartFromDatetimeStr(time_key)
          start_key = time_key
        }
        last_key = time_key
      }
      if (start_key) {
        this.has_map = true
      }
      else {
        this.has_map = false
      }
      if (!this.has_map) {
        return
      }
      // end_hour這樣就對了不用再判斷調整(因為是"開始"時間且時段至少有一分鐘且當前時段皆不超過一小時)
      end_hour = this.getPartFromDatetimeStr(last_key)
      // 最複雜的處理在這裡做
      for (let i=start_hour; i<= end_hour; i++) {
        this.op_hours.push({
          hour:i,
          text:((i<10?'0':'')+i)
        })
      }
      datehour = this.getPartFromDatetimeStr(start_key, 'datehour')
      // 接著是複雜的右邊時段
      //第一個時段由start_key是否是整點判斷
      if (this.getPartFromDatetimeStr(start_key, 'minute') > 0) {
        this.cal_blocks.push({
          id:0,
          start_time: datehour,
          end_time: start_key,
          duration:this.getPartFromDatetimeStr(start_key, 'minute'),
          overlays:0,
          auto_accept_count:0
        })
      }
      for (let time_key in res_map) {
        let is_highlight_start = false
        let is_highlighted = false
        let is_highlight_end = false
        if (this.highlight_from && time_key === this.highlight_from) {
          is_highlight_start = true
        }
        if (this.highlight_from && this.highlight_to && time_key >= this.highlight_from && res_map[time_key].end_time <= this.highlight_to) {
          is_highlighted = true
        }
        if (res_map[time_key].end_time === this.highlight_to) {
          is_highlight_end = true
        }
        // 正常情況都是連續的,只有被休息時段截掉才會不連續,此時要額外產生一個時段
        if (time_key !== prev_end_time && prev_end_time !== null) {
          dt1 = this.getTimestampFromDatetimeStr(prev_end_time)
          dt2 = this.getTimestampFromDatetimeStr(time_key)
          this.cal_blocks.push({
            id:0,
            start_time: prev_end_time,
            end_time: time_key,
            duration:((dt2-dt1)/60000),
            overlays:0,
            auto_accept_count:0
          })
        }
        dt1 = this.getTimestampFromDatetimeStr(time_key)
        dt2 = this.getTimestampFromDatetimeStr(res_map[time_key].end_time)
        this.cal_blocks.push({
          id:res_map[time_key].store_possible_reserve_time_id,
          start_time: time_key,
          end_time: res_map[time_key].end_time,
          duration:((dt2-dt1)/60000),
          overlays:res_map[time_key].overlays,
          auto_accept_count:res_map[time_key].auto_accept_count,
          is_highlight_start:is_highlight_start,
          is_highlighted:is_highlighted,
          is_highlight_end:is_highlight_end
        })
        prev_end_time = res_map[time_key].end_time
      }
      // 最後一個時段如果不是整點結束需補上最後一段到最後一小時結束的block
      if (this.getPartFromDatetimeStr(prev_end_time, 'minute') !== 0) {
        this.cal_blocks.push({
          id:0,
          start_time: prev_end_time,
          end_time: this.getPartFromDatetimeStr(last_key, 'datehour'),
          duration:(60-this.getPartFromDatetimeStr(prev_end_time, 'minute')),
          overlays:0,
          auto_accept_count:0
        })
      }
    }
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
    else {
      this.service_minute_unit = parseInt(this.$bus.session.store_service_rule.service_minute_unit)
    }
    if (this.$bus.linkCallStack.length) {
      this.fromParams = this.$bus.linkCallStack.pop().params
      this.fromStack = this.CpObj(this.$bus.linkCallStack)
      this.$bus.linkCallStack = []
    }
  },
  mounted () {
    // 動態根據表單呼叫狀態控制按鈕的顯示/disabled需要寫在這裡(data裡的filterOptions不能宣告動態屬性因為那只會跑一次不會跟著組件狀態而變化)
    if (this.fromStack && this.fromStack.length) {
      // 上面埋一行按鈕,從外面呼叫進入時提供以返回為首的一組操作按鈕
      this.filterOptions[2].hide = false
      // 有傳劃位請求id時才需要顯示接受與拒絕的按鈕
      if (this.fromParams && this.fromParams.negotiation_id) {
        this.filterOptions[2].buttons[1].hide = false
        this.filterOptions[2].buttons[2].hide = false
        this.filterOptions[2].buttons[3].hide = false
        
        // 用negotiation_id撈出open_date,highlight_from,highlight_to
        // 因為呼叫api的非同步特性會讓畫面處理變複雜,所以跳過來之前就先呼叫api抓好資料set那三個屬性,抓好再跳過來
        this.fromParams.highlight_from = this.fromParams.data.start_time
        this.fromParams.highlight_to = this.fromParams.data.end_time
        this.fromParams.open_date = this.fromParams.data.open_date
        this.filterOptions[0].hide = false
        this.filterOptions[1].hide = false
        // 組劃位請求資訊
        this.filterOptions[0].placeholder = this.fromParams.data.user_name+'請求'+this.fromParams.data.start_time+':'+this.fromParams.data.from_remark
        this.filterOptions[3].hide = true
        this.filterOptions[4].hide = true
      }
      else if (this.fromParams && this.fromParams.reservation_id) {
        //this.filterOptions[2].buttons[1].hide = true
        this.filterOptions[2].buttons[2].hide = true
        this.filterOptions[2].buttons[3].hide = true
        this.fromParams.highlight_from = this.fromParams.data.reserve_start_time
        this.fromParams.highlight_to = this.fromParams.data.reserve_end_time
        this.fromParams.open_date = this.getPartFromDatetimeStr(this.fromParams.data.reserve_start_time,'date')
        this.filterOptions[0].hide = false
        this.filterOptions[0].placeholder = this.fromParams.data.reserve_user_name+'完成對'+this.fromParams.data.service_name+'的劃位'
        this.filterOptions[1].hide = true
        this.filterOptions[3].hide = false
        this.filterOptions[4].hide = false
        //進入後順便call api更新為已讀
        // 只是看看沒有要把某confirm_task變已讀,沒傳mwct_id時不用顯示確認按鈕
        if (this.fromParams.mwct_id) {
          this.filterOptions[2].buttons[1].placeholder = "確認"
          this.filterOptions[2].buttons[1].execCallback = this.ConfirmRead
        }
        else {
          this.filterOptions[2].buttons[1].hide = true
        }
      }
      else {
        this.filterOptions[2].buttons[1].hide = true
        this.filterOptions[2].buttons[2].hide = true
        this.filterOptions[2].buttons[3].hide = true
        this.filterOptions[0].hide = true
        this.filterOptions[1].hide = true
        this.filterOptions[3].hide = false
        this.filterOptions[4].hide = false
      }
    }
    this.$refs.filterForm.initDefault()
    if (this.fromParams) {
      // 由pass參數初始化的有指定日期與指定聚焦起訖時段兩種
      if (this.fromParams.open_date) {
        this.filterData.viewDate = this.fromParams.open_date
        this.$refs.filterForm.refreshModelVar('viewDate')
      }
      if (this.fromParams.highlight_from && this.fromParams.highlight_to) {
        this.highlight_from = this.fromParams.highlight_from
        this.highlight_to = this.fromParams.highlight_to
        this.filter_time = this.getPartFromDatetimeStr(this.highlight_from,'hourminute')
      }
    }
    if (this.filterData.viewDate) {
      this.get_date_data()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-small {
  font-size: x-small;
  padding-left: 0px;
  padding-right: 0px;
}

.rc-bar-view {
  float:left;
  height:70vh;
  overflow-y: scroll;
}
.rv-list-view {
  float:left;
  font-size: x-small;
  padding-left: 0px;
  padding-right: 0px;
  height:70vh;
  overflow-y: scroll;
}
</style>
